<template>

    <div class="menu-container-hl">

        <mq-layout mq="lg" class="part-a" v-if="show">

            <div class="menu-container-bm">

                <nav class="menu-content">

                    <div class="menu-bloc-blue">

                        <div class="infos-container">

                            <img src="/img/logo/large/white.svg" class="header-container-img pointer" @click="$router.push({ path: '/newsletters'})">

                        </div>

                    </div>

                    <!--NEWSLETTERS-->
                    <div class="bloc-grey" @click="tagClick('newsletters');clickMenu('newsletters')" :class="{ selected: isActive(newsletters) }">
                        <img class="bloc-grey-icon" :src="menuIcon('newsletters', newsletters)"/>

                        <div class="bloc-grey-text">
                            {{ $t('menu_newsletters')}}
                        </div>

                        <div class="little-arrow-container">

                            <img src="/img/icons/little-arrow-right.svg" v-if="!isActive(newsletters)">

                        </div>

                    </div>

                    <!--STATS-->
                    <div class="bloc-grey" @click="tagClick('stats');clickMenu('stats')" :class="{ selected: isActive(stats) }">

                        <img class="bloc-grey-icon" :src="menuIcon('stats', stats)"/>

                        <div class="bloc-grey-text">
                            {{ $t('menu_statistics')}}
                        </div>

                        <div class="little-arrow-container">

                            <img src="/img/icons/little-arrow-right.svg" v-if="!isActive(stats)">

                        </div>

                    </div>

                    <!--SETTINGS-->
                    <div class="bloc-grey" @click="tagClick('settings');clickMenu('settings')" :class="{ selected: isActive(settings) }">

                        <img class="bloc-grey-icon" :src="menuIcon('settings', settings)"/>

                        <div class="bloc-grey-text">
                            {{ $t('menu_settings')}}
                        </div>

                        <div class="little-arrow-container">

                            <img src="/img/icons/little-arrow-right.svg" v-if="!isActive(settings)">

                        </div>

                    </div>

                    <div class="last-bloc"></div>

                </nav>

            </div>

        </mq-layout>

        <div class="site-container part-b">

            <slot></slot>

        </div>

    </div>

</template>

<script>

import Vuex from 'vuex'

import Storage from '@/helpers/storage'

import Tag from '@/modules/tag'

export default {

    name: 'header-left',


    watch:{
        $route (route){

            if(Storage.getItem('fetchStatus') === 'done') {

                this.show = this.pagesWithHeaderLeft.indexOf(route.name) > -1

            } else {

                this.show = false
            }

        },

        show: function (bool) {

            this.updateLeftMenu(bool && this.$mq === 'lg')
        },

        $mq (bool) {

            this.updateLeftMenu(bool && this.show)
        }
    },

    data () {
        return {

            show: false,
            newsletters: ['/newsletters', '/my-actions'],
            stats: ['/stats', '/weforest'],
            settings: ['/settings'],
            pagesWithHeaderLeft: [
                'newsletters',
                'my-actions',
                'stats',
                'settings',
                'weforest'
            ]

        }
    },

    methods: {

        ...Vuex.mapActions([
            'updateLeftMenu'
        ]),

        isActive: function (array) {

            return array.includes(this.$route.fullPath)

        },

        menuIcon: function (icone, array) {

            return `/img/icons/tab-bar-${icone}-${this.isActive(array) ? 'blue' : 'white'}.svg`
        },

        clickMenu (page) {

            if (this.$route.fullPath !== '/' + page) {

                this.$router.push({ path: '/' + page })

            }
        },

        tagClick (action) {

            Tag.clickAmplitude(this, action)
        }
    }

}

</script>

<style scoped lang="scss">

    .menu-container-hl {
        display: flex;
        flex-direction: row;
    }

    .site-container {
        /*relative for modal absolute*/
        position: relative;

        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .part-a {
        background-color: $blue;
    }

    .part-b {
        position: relative;
    }


    .menu-container-bm {
        width: 100%;
        min-height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        background-color: $white;
        display: flex;
        flex-direction: column;
        max-width: 300px;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $blue;
            position: relative;
            min-width: 320px;
        }
    }

    .menu-bloc-blue {
        background-color: $blue;
        padding-bottom: 36px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 24px 31px;
        }
    }

    .header-container-img {
        object-fit: contain;
        height: 46px;
        margin-right: 16px;
    }

    .infos-container {
        height: 40px;
        margin-top: 9px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 40px;
        @media screen and (min-width: $above-tablet-length) {
            margin: 0;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0;
        }
    }

    .bloc-grey {
        height: 72px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color: $blue;
        cursor: pointer;
        padding: 24px 32px;
        color: $white;
    }

    .bloc-grey:hover {
        background-color: $aquamarine;
    }

    .bloc-grey-icon {
        width: 24px;
        height: 24px;
        margin-right: 16px;
    }

    .bloc-grey-text {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        flex-grow: 1;
        text-align: left;
    }

    .little-arrow-container {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .selected {
        background-color: $white;
        color: $blue;
    }

    .selected:hover {
        background-color: $white;
    }

    .menu-content {
        overflow: scroll;
        height: 100vh;
        background-color: $blue;
        @media screen and (min-width: $above-tablet-length) {
            overflow: inherit;
            width: 320px;
            height: 100%;
            position: fixed;
        }
    }

</style>
